export default __webpack_public_path__ + "static/media/logo-grayscale.6c4837bd.svg";